import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { JsonLd, SITE_URL } from "@/lib/seo";

export const Breadcrumbs = ({ items }) => {
  const trail = [{ label: "Inicio", to: "/" }, ...items];
  return (
    <>
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: trail.map((it, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: it.label,
          ...(it.to ? { item: `${SITE_URL}${it.to === "/" ? "" : it.to}` } : {}),
        })),
      }} />
      <nav aria-label="Migas de pan" data-testid="breadcrumbs" className="flex items-center flex-wrap gap-1 text-sm">
        {trail.map((it, i) => (
          <React.Fragment key={it.label}>
            {i > 0 && <ChevronRight size={13} className="text-[var(--faro-text-soft)] shrink-0" />}
            {it.to && i < trail.length - 1 ? (
              <Link to={it.to} className="font-bold text-[var(--faro-blue)] hover:text-[var(--faro-red)]">{it.label}</Link>
            ) : (
              <span className="text-[var(--faro-text-soft)] font-semibold">{it.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
};
